//const API_BASE = import.meta.env.VITE_API_URL || "https://www.logiqsoftapi.somee.com/api/v1";
//const API_BASE = "http://localhost:5020/api/v1.0";
const API_BASE = "https://www.logiqsoftapi.somee.com/api/v1";

export function getApiBase() {
  return API_BASE;
}

export async function apiGet<T>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const token = localStorage.getItem("admin_token");
  const headers: HeadersInit = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options?.headers as Record<string, string>),
  };

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    method: "GET",
  });

  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(json?.message || `HTTP ${res.status}`);
  }
  return json as T;
}

export async function apiPost<T>(
  path: string,
  body?: unknown,
  options?: RequestInit
): Promise<T> {
  const token = localStorage.getItem("admin_token");
  const headers: HeadersInit = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options?.headers as Record<string, string>),
  };

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    method: "POST",
    body: body ? JSON.stringify(body) : undefined,
  });

  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(json?.message || json?.errors?.[0] || `HTTP ${res.status}`);
  }
  return json as T;
}

export async function apiPatch<T>(
  path: string,
  body: unknown,
  options?: RequestInit
): Promise<T> {
  const token = localStorage.getItem("admin_token");
  const headers: HeadersInit = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options?.headers as Record<string, string>),
  };

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    method: "PATCH",
    body: JSON.stringify(body),
  });

  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(json?.message || json?.errors?.[0] || `HTTP ${res.status}`);
  }
  return json as T;
}

export async function apiDelete(path: string, options?: RequestInit): Promise<void> {
  const token = localStorage.getItem("admin_token");
  const headers: HeadersInit = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options?.headers as Record<string, string>),
  };

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    method: "DELETE",
  });

  if (!res.ok) {
    const json = await res.json().catch(() => null);
    throw new Error(json?.message || json?.errors?.[0] || `HTTP ${res.status}`);
  }
}

export async function apiPostForm<T>(
  path: string,
  formData: FormData,
  options?: RequestInit
): Promise<T> {
  const token = localStorage.getItem("admin_token");
  const headers: HeadersInit = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options?.headers as Record<string, string>),
  };
  delete (headers as Record<string, string>)["Content-Type"];

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    method: "POST",
    body: formData,
  });

  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(json?.message || json?.errors?.[0] || `HTTP ${res.status}`);
  }
  return json as T;
}

export async function apiPatchForm<T>(
  path: string,
  formData: FormData,
  options?: RequestInit
): Promise<T> {
  const token = localStorage.getItem("admin_token");
  const headers: HeadersInit = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options?.headers as Record<string, string>),
  };
  delete (headers as Record<string, string>)["Content-Type"];

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    method: "PATCH",
    body: formData,
  });

  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(json?.message || json?.errors?.[0] || `HTTP ${res.status}`);
  }
  return json as T;
}
